import { useState } from "react";
import { buildWeavingAlert } from "../../_events/weaving_alert/model";
import { createWeavingAlertEvent } from "../../_events/weaving_alert/create.event";
import { message } from "antd";

export const useCreateWeavingAlert = () => {
    const [entity, setEntity] = useState(buildWeavingAlert());
    const [loading, setLoading] = useState(false);

    const create = (onSuccess) => {
        setLoading(true);
        createWeavingAlertEvent(entity)
        .then(_ => {
            message.success('Alerta creada');
            onSuccess?.();
            setLoading(false);
        })
        .catch(error => {
            message.error(error.message);
            setLoading(false);
        });
    } 

    return{
        entity,
        loading,
        setEntity,
        create,
    };
}